import { ReactNode } from 'react'
import { REGEXP_ONLY_DIGITS } from 'input-otp'
import FieldDescription from 'components/ui/FieldDescription'
import FieldError from 'components/ui/FieldError'
import { InputOTP, InputOTPGroup, InputOTPSlot } from 'components/ui/input-otp'

export const CODE_LENGTH = 6

export type Props = {
  value: string
  onChange: (value: string) => void
  onComplete: (value: string) => void
  description?: ReactNode
  error?: string | null
  disabled?: boolean
  className?: string
}

export default function ConfirmationCodeField({
  value,
  onChange,
  onComplete,
  description,
  error,
  disabled = false,
  className
}: Props) {
  return (
    <div className={className}>
      <FieldDescription>{description}</FieldDescription>
      <InputOTP
        aria-invalid={!!error}
        aria-label="Confirmation code"
        autoComplete="one-time-code"
        autoFocus
        containerClassName="justify-center"
        disabled={disabled}
        inputMode="numeric"
        maxLength={CODE_LENGTH}
        onChange={onChange}
        onComplete={onComplete}
        pattern={REGEXP_ONLY_DIGITS}
        value={value}
      >
        <InputOTPGroup className="gap-3">
          {Array.from({ length: CODE_LENGTH }, (_, index) => (
            <InputOTPSlot index={index} key={index} />
          ))}
        </InputOTPGroup>
      </InputOTP>
      <FieldError>{error}</FieldError>
    </div>
  )
}
